import React, { useState, useEffect, useRef } from 'react';

const SettingsPopup = ({ settings, onSettingsChange, onClose, anchorRef }) => {
    const [localSettings, setLocalSettings] = useState(settings);
    const popupRef = useRef(null);

    useEffect(() => {
        setLocalSettings(settings);
        if (anchorRef.current && popupRef.current) {
            const buttonRect = anchorRef.current.getBoundingClientRect();
            popupRef.current.style.position = 'absolute';
            popupRef.current.style.top = `${buttonRect.bottom + window.scrollY}px`;
            popupRef.current.style.right = `${window.innerWidth - buttonRect.right + window.scrollX}px`;
            popupRef.current.style.transform = 'translateX(10px)';
        }
    }, [settings, anchorRef]);

    const handleChange = (e) => {
        const { name, checked, value } = e.target;
        const newSettings = { ...localSettings };
        if (name === "rowLimit") {
            newSettings.rowLimit = parseInt(value);
        } else if (name === "showAllTransactions" && checked) {
            newSettings.showDate = true;
            newSettings.showType = true;
            newSettings.showNumber = true;
            newSettings.showPayee = true;
            newSettings.showClass = true;
            newSettings.showLocation = true;
            newSettings.showStatus = true;
            newSettings.showMethod = true;
            newSettings.showSource = true;
            newSettings.showCategory = true;
            newSettings.showMemo = true;
            newSettings.showDueDate = true;
            newSettings.showBalance = true;
            newSettings.showTotalBalanceSalesTax = true;
            newSettings.showSalesTax = true;
            newSettings.showTotal = true;
            newSettings.showAttachments = true;
            newSettings.showBillApproval = true;
            newSettings.showAction = true;
        } else if (name === "showAllTransactions" && !checked) {
            newSettings.showAllTransactions = false;
        } else {
            newSettings[name] = checked;
        }
        setLocalSettings(newSettings);
        onSettingsChange(newSettings);
    };

    return (
        <div ref={popupRef} className="settings-popup" style={{
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '15px',
            zIndex: 1000,
            maxHeight: '400px',
            overflowY: 'auto',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            minWidth: '250px',
            fontFamily: 'Arial, sans-serif',
        }}>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showAllTransactions"
                    checked={localSettings.showAllTransactions}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show All Transactions
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showDate"
                    checked={localSettings.showDate}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Date
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showType"
                    checked={localSettings.showType}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Type
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showNumber"
                    checked={localSettings.showNumber}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Number
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showPayee"
                    checked={localSettings.showPayee}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Payee
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showClass"
                    checked={localSettings.showClass}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Class
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showLocation"
                    checked={localSettings.showLocation}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Location
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showStatus"
                    checked={localSettings.showStatus}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Status
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showMethod"
                    checked={localSettings.showMethod}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Method
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showSource"
                    checked={localSettings.showSource}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Source
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showCategory"
                    checked={localSettings.showCategory}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Category
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showMemo"
                    checked={localSettings.showMemo}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Memo
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showDueDate"
                    checked={localSettings.showDueDate}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Due Date
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showBalance"
                    checked={localSettings.showBalance}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Balance
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showTotalBalanceSalesTax"
                    checked={localSettings.showTotalBalanceSalesTax}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Total Balance Sales Tax
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showSalesTax"
                    checked={localSettings.showSalesTax}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Sales Tax
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showTotal"
                    checked={localSettings.showTotal}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Total
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showAttachments"
                    checked={localSettings.showAttachments}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Attachments
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showBillApproval"
                    checked={localSettings.showBillApproval}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Bill Approval
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                <input
                    type="checkbox"
                    name="showAction"
                    checked={localSettings.showAction}
                    onChange={handleChange}
                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                /> Show Action
            </label>
            <label style={{ display: 'block', marginBottom: '10px', padding: '5px' }}>
                Rows to Show:
                <select 
                    name="rowLimit" 
                    value={localSettings.rowLimit} 
                    onChange={handleChange} 
                    style={{ 
                        marginLeft: '8px', 
                        padding: '4px 8px', 
                        borderRadius: '4px', 
                        border: '1px solid #ccc',
                        backgroundColor: localSettings.rowLimit ? '#f0f8ff' : '#fff',
                        fontSize: '14px'
                    }}
                >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                </select>
            </label>
            <button 
                onClick={onClose} 
                style={{ 
                    marginTop: '15px', 
                    padding: '10px 15px', 
                    background: '#bbbbbb', 
                    color: 'black', 
                    border: '1px solid grey', 
                    borderRadius: '4px', 
                    cursor: 'pointer', 
                    width: '100%' 
                }}
            >
                Close
            </button>
        </div>
    );
};

export default SettingsPopup;